import React from "react";
import { HiOutlineEye } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { PlanTier, usePermissions } from "../../utils/permissions";
import useAuth from "../../hooks/useAuth";
import OptionToggleRow from "./OptionToggleRow";

interface ShowFooterToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  title?: string;
  description?: string;
}

const ShowFooterToggle: React.FC<ShowFooterToggleProps> = ({
  enabled,
  onChange,
  title,
  description,
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const permissions = usePermissions(user);

  const hasPermission = !permissions.isPlanTier(PlanTier.FREE);

  return (
    <OptionToggleRow
      icon={HiOutlineEye}
      iconClassName="text-blue-600"
      title={title ?? t("businessCardPage.optionsTab.footerVisibility.title")}
      description={
        description ??
        t("businessCardPage.optionsTab.footerVisibility.subLabel")
      }
      enabled={enabled}
      onChange={(value) => hasPermission && onChange(value)}
      disabled={!hasPermission}
    />
  );
};

export default ShowFooterToggle;
